import { HttpMethod } from '@previo/core'
import { APIPaths } from '~/http/APIPaths'
import Http from '~/http/Http'
import type { Role } from '~/http/roles/types'

export class RolesAPI extends Http {
  all = (): Promise<Role[]> => {
    return this.callAuthWithPropertyAPI<null, Role[]>(HttpMethod.GET, { path: APIPaths.ROLES })
  }
}
